import script from "./Public.vue?vue&type=script&setup=true&lang=js"
export * from "./Public.vue?vue&type=script&setup=true&lang=js"

import "./Public.vue?vue&type=style&index=0&id=38aeef2e&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38aeef2e"]])

export default __exports__